import React from 'react';
import Link from 'next/link';

interface SectionHeaderProps {
    label?: string;
    uri?: string;
    type?: string;
    setOpen?: (state: boolean) => void;
}

const SectionHeader = ({ label, uri, type, setOpen }: SectionHeaderProps) => {
    return (
        <div
            className={
                'flex w-full border border-primary/5 dark:border-white/5 gap-1 items-center text-xs text-white bg-progress justify-center py-4'
            }
        >
            {type === 'gold-platforms' ? <p>مشاهده لیست معتبرترین</p> : <p>مشاهده لیست کامل</p>}

            <Link
                onClick={() => (setOpen ? setOpen(false) : true)}
                aria-label={`link to ${label}`}
                className={'underline underline-offset-4 decoration-white/40'}
                href={uri || '#'}
            >
                {label}
            </Link>
        </div>
    );
};

export default SectionHeader;
